export default ['$rootScope', function ($rootScope) {
    return {
        get: () => {
            return $rootScope.currentProperty;
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/currentProperty.service.js